// DS1.7.22
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import Flex from '@wix/da-ds/pkg/Flex/Flex';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { URLS } from '@wix/da-url';
import { BiEvent } from '@wix/da-bi/pkg/events';
import { getCurrentUserHasCore } from '../../publicSession/selectors';

import s from './CoreExclusiveFeature.scss';

interface Props {
  className?: string;
  withoutBuyCTA?: boolean;
  biData?: BiEvent;
}

const CoreExclusiveFeature: React.FC<Props> = ({
  className,
  withoutBuyCTA,
  biData,
}) => {
  const { t } = useTranslation();
  const hasCore = useSelector(getCurrentUserHasCore);

  return (
    <div className={className}>
      {hasCore || withoutBuyCTA ? (
        <Flex gap={4} alignItems="center">
          <CoreSymbol size={IconSize.SMALLER} />
          <div className={s['core-exclusive']}>{t('common.coreExclusive')}</div>
        </Flex>
      ) : (
        <Flex gap={8} alignItems="center">
          <div className={s['core-exclusive']}>{t('common.coreExclusive')}</div>
          <Flex gap={4} alignItems="center">
            <CoreSymbol size={IconSize.SMALLER} />
            <BiLink
              className={s['cta']}
              href={URLS.CORE_MEMBERSHIP}
              biData={biData}
            >
              {t('common.upgradeToCoreCTA')}
            </BiLink>
          </Flex>
        </Flex>
      )}
    </div>
  );
};
CoreExclusiveFeature.displayName = 'CoreExclusiveFeature';

export default CoreExclusiveFeature;
